import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Flex, Box } from 'grid-styled';
import PropTypes from 'prop-types';

import { UnderlinedHeading } from '../styles/UnderlinedHeading';
import ProductConfigurationListItem from './ProductConfigurationListItem';
import ProductConfigurationListItemMobile from './ProductConfigurationListItemMobile';

const ProductConfigurationList = props => {
  const childrenList = props.children.map((item, index) => (
    <ThemeProvider
      key={index}
      theme={{
        breakpoints: ['1200px']
      }}
    >
      <Box width={[1 / 3, 1 / 4]} px="5px">
        <ProductConfigurationListItem
          fullImages={props.fullImages}
          type={props.type}
          selected={props.selected}
          location={props.location}
          setProductVariant={props.setProductVariant}
        >
          {item}
        </ProductConfigurationListItem>
      </Box>
    </ThemeProvider>
  ));

  const childrenListMobile = props.children.map((item, index) => (
    <ProductConfigurationListItemMobile
      roundImages={props.roundImages}
      key={index}
      type={props.type}
      selected={props.selected}
      location={props.location}
      setProductVariant={props.setProductVariant}
      price={props.price}
      selectedOptionPrice={props.selectedOptionPrice}
      totalSelectedOptionPrice={props.totalSelectedOptionPrice}
    >
      {item}
    </ProductConfigurationListItemMobile>
  ));

  if (props.isMobileDevice) {
    return (
      <ProductConfigurationListContainer>
        <UnderlinedHeading>{props.title}</UnderlinedHeading>
        {childrenListMobile}
      </ProductConfigurationListContainer>
    );
  }

  return (
    <ProductConfigurationListContainer>
      <Flex flexWrap="wrap" mx="-5px">
        {childrenList}
      </Flex>
    </ProductConfigurationListContainer>
  );
};

const ProductConfigurationListContainer = styled.div`
  width: 100%;
  margin: 10px 0;
`;

ProductConfigurationList.defaultProps = {
  fullImages: false,
  roundImages: false,
  isMobileDevice: false,
  title: '',
  selected: '',
  type: null,
  price: null,
  selectedOptionPrice: null,
  totalSelectedOptionPrice: null,
};

ProductConfigurationList.propTypes = {
  selected: PropTypes.string,
  setProductVariant: PropTypes.func.isRequired,
  fullImages: PropTypes.bool,
  roundImages: PropTypes.bool,
  isMobileDevice: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  type: PropTypes.string,
  location: PropTypes.string.isRequired,
  price: PropTypes.number,
  selectedOptionPrice: PropTypes.number,
  totalSelectedOptionPrice: PropTypes.number,
};

export default ProductConfigurationList;



// WEBPACK FOOTER //
// ./src/components/ProductConfigurationList.js